import { useMemo } from 'react';
import { useMaterialReactTable, MaterialReactTable } from 'material-react-table';
import { connect } from 'react-redux';
import { Typography, Alert } from '@mui/material';
import { displayDuration, dateTime } from '../../../utils/parsing';

const DataPreview = ({ stats }) => {
  const firstTime = stats.first * 1000;
  const lastTime = stats.last * 1000;
  const duration = displayDuration(lastTime - firstTime, 'millis');
  const columns = useMemo(
    () => [
      {
        accessorKey: 'name',
        header: 'Field Name',
        filterVariant: 'select',
      },
      {
        id: 'start',
        header: 'Start of Gap',
        accessorFn: ({ start }) => (start ? new Date(start * 1000) : undefined),
        filterVariant: 'date-range',
        Cell: ({ cell }) =>
          cell.getValue()
            ? `${cell.getValue().toLocaleDateString()} ${cell.getValue().toLocaleTimeString()}`
            : undefined,
      },
      {
        id: 'end',
        header: 'End of Gap',
        accessorFn: ({ end }) => (end ? new Date(end * 1000) : undefined),
        filterVariant: 'date-range',
        Cell: ({ cell }) =>
          cell.getValue()
            ? `${cell.getValue().toLocaleDateString()} ${cell.getValue().toLocaleTimeString()}`
            : undefined,
      },
      {
        accessorKey: 'missing',
        header: 'Missing Value Count',
        filterVariant: 'range',
      },
      {
        id: 'length',
        accessorFn: ({ length }) => Number.parseFloat(length / 60 / 60 / 24).toFixed(2),
        header: 'Length of Gap (days)',
        filterVariant: 'range',
      },
    ],
    []
  );
  const mrt = useMaterialReactTable({
    enableFacetedValues: true,
    muiTableHeadCellProps: {
      sx: {
        textAlign: 'center',
        verticalAlign: 'middle',
        '& .Mui-TableHeadCell-Content': {
          justifyContent: 'center',
        },
      },
    },
    muiTableBodyCellProps: { sx: { textAlign: 'center', verticalAlign: 'middle' } },
    // TODO: Pull these into a common from explore/util.jsx
    columns,
    data: stats.gaps,
    initialState: {},
    localization: {
      noRecordsToDisplay: 'No gaps found',
    },
  });
  return (
    <>
      <Typography variant="h6"> Elapsed Time Check </Typography>
      <Typography variant="body2">
        First Recorded Point: {dateTime(firstTime)}
        <br />
        Last Recorded Point: {dateTime(lastTime)}
        <br />
        Time Elapsed in Dataset: {duration.val} {duration.unit}
      </Typography>
      {lastTime - firstTime < 6 * 30 * 24 * 60 * 60 * 1000 ? (
        <Alert severity="error" variant="filled">
          This is NOT a sufficient amount of data.
        </Alert>
      ) : (
        <Alert severity="success">This is a sufficient amount of data.</Alert>
      )}
      <MaterialReactTable table={mrt} />
    </>
  );
};

export default connect()(DataPreview);
